module.exports = __webpack_public_path__ + "img/laptop.c2c54e96.svg";